/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import routes from './config/routes';
import { RequireAuth } from './utils/requireAuth';
import { SideBar } from './components/sidebar';

const Application: React.FC<{}> = props => (
  <div>
    <BrowserRouter>
      <Routes>
        {routes.map((route, index) => {
          if (
            route.path === '/' ||
            route.path === '/change-password' ||
            route.path === '/reset-password' ||
            route.path === '/sign-up'
          ) {
            return (
              <Route
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                path={route.path}
                element={<route.element {...props} {...route.props} />}
              />
            );
          }
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <RequireAuth>
                  <SideBar {...props} {...route.props}>
                    <route.element {...props} {...route.props} />
                  </SideBar>
                </RequireAuth>
              }
            />
          );
        })}
      </Routes>
    </BrowserRouter>
  </div>
);

export default Application;
